import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

import logo from "../../assets/publicpageimg/skillediton-logo1.png";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { useNavigate } from "react-router-dom";

import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="skilledition-footer ">
      <Container className="skilledition-footer-container">
        <Row className="skilledition-footer-top">
          {/* BRAND INFO */}
          <Col lg={4} md={6} className="skilledition-footer-brand">
            <img
              src={logo}
              alt="Skilledition Logo"
              className="skilledition-footer-logo"
            />
            <p className="skilledition-footer-text">
              Skilledition provides career-focused training to help beginners
              build strong technical skills through accessible learning in
              Telugu. Our programs focus on concept understanding, practical
              learning, and real-world development.
            </p>

            <div className="skilledition-footer-social">
              <a
                href="https://www.linkedin.com/showcase/skilledition/"
                target="_blank"
                rel="noopener noreferrer"
                className="skilledition-social-icon"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>

              <a
                href="https://www.instagram.com/skilledition.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="skilledition-social-icon"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              
              <a
                href="https://www.facebook.com/people/SkillEdition/61591093764563/"
                target="_blank"
                rel="noopener noreferrer"
                className="skilledition-social-icon"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
            </div>
          </Col>

          {/* QUICK LINKS */}
          {/* QUICK LINKS */}
          <Col lg={3} md={6} className="skilledition-footer-links">
            <h6 className="skilledition-footer-title">Quick Links</h6>
            <ul className="skilledition-footer-list">
              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/courses")}
              >
                Explore Courses
              </li>
              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/internship-programme")}
              >
                Internship Programme
              </li>
              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/tutor-programme")}
              >
                Tutor Programme
              </li>
              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/about")}
              >
                About Us
              </li>

              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/contact")}
              >
                Contact Us
              </li>
              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/terms")}
              >
                Terms & Conditions
              </li>
              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/privacy")}
              >
                Privacy Policy
              </li>
            </ul>
          </Col>

          {/* TOP COURSES */}
          <Col lg={3} md={6} className="skilledition-footer-links">
            <h6 className="skilledition-footer-title">Top Courses</h6>
            <ul className="skilledition-footer-list">
              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/frontend-development")}
              >
                Frontend Development
              </li>
              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/backend-development")}
              >
                Backend Development
              </li>
              {/* <li
                className="skilledition-footer-item"
                onClick={() => navigate("/mern-stack")}
              >
                MERN Stack Development
              </li> */}
              {/* <li
                className="skilledition-footer-item"
                onClick={() => navigate("/digital-marketing")}
              >
                Digital Marketing
              </li>
              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/data-analytics")}
              >
                Data & Analytics
              </li>
              <li
                className="skilledition-footer-item"
                onClick={() => navigate("/uiux-designer")}
              >
                UI/UX Designer
              </li> */}
            </ul>
          </Col>

          {/* CONTACT */}
          <Col lg={2} md={6} className="skilledition-footer-contact">
            <h6 className="skilledition-footer-title">Contact us</h6>
            <div className="skilledition-footer-contact">
              <a
                href="https://www.google.com/maps/place/Digisphere+Tech/@16.5217646,80.6730738,685m/data=!3m3!1e3!4b1!5s0x3a35e4d5faee43b7:0x62b448ca13b11006!4m6!3m5!1s0x3a35e50066e15829:0xc4b7cda4c9c7613f!8m2!3d16.5217595!4d80.6756487!16s%2Fg%2F11v_5nd3q_?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="skilledition-footer-contact-text"
              >
                <span className="skilledition-footer-contact-icon">
                  <FaMapMarkerAlt />
                </span>
                Vijayawada
              </a>

              <a
                href="tel:+918143879627"
                className="skilledition-footer-contact-text"
              >
                <span className="skilledition-footer-contact-icon">
                  <FaPhoneAlt />
                </span>
                +91 8143 8796 27
              </a>
            </div>

            <Button
              className="skilledition-footer-btn whatsapp"
              onClick={() =>
                window.open("https://wa.me/918143879627", "_blank")
              }
            >
              <IoLogoWhatsapp className="btn-icon" />
              WhatsApp
            </Button>
          </Col>
        </Row>

        <hr className="skilledition-footer-divider" />

        {/* BOTTOM */}
        <Row className="skilledition-footer-bottom">
          <Col md={6} className="skilledition-footer-bottom-left">
            Design & Developed by
            <a
              href="https://digispheretech.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="skilledition-footer-bottom-company-label"
            >
              Digisphere
            </a>
          </Col>
          <Col md={6} className="skilledition-footer-bottom-right">
            © 2026 Skilledition
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
